import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

export const getSimilaritiesData = (state: IRootState) => state.similarities.data;
export const getSimilaritiesPage = (state: IRootState) => state.similarities.page;
export const getSimilaritiesPageCount = (state: IRootState) => state.similarities.pageCount;
export const getSimilaritiesTotalCount = (state: IRootState) => state.similarities.totalCount;
export const getSimilaritiesOrder = (state: IRootState) => state.similarities.order;
export const getSimilaritiesFilter = (state: IRootState) => state.similarities.filter;
export const getSimilaritiesSearchString = (state: IRootState) => state.similarities.searchString;
export const getSimilaritiesNotProcessedCount = (state: IRootState) => state.similarities.notProcessedCount;
export const getSimilaritiesDataById = (state: IRootState) => state.similarities.similaritiesById;
export const getSimilaritiesPersonId = (state: IRootState) => state.similarities.personId;
export const getSimilaritiesOrderById = (state: IRootState) => state.similarities.orderById;
export const getSimilaritiesFilterById = (state: IRootState) => state.similarities.filterById;
export const getSimilaritiesSettings = (state: IRootState) => state.similarities.settings;
